import { Component, OnInit, Inject } from '@angular/core';
import { ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../../shared/dialogs/confirm/confirm.component';
import { SlotService } from '../../../services/slot.service';
import { Slot } from '../../../models/slot';
import { AuthService } from '../../../services/auth.service';
import { SnackBarIconService } from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import { Subcategory } from 'src/app/models/subcategory';
import { SubcategoryService } from 'src/app/services/subcategory.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-event-slot-dialog',
  templateUrl: './event-slot-dialog.component.html',
  styleUrls: ['./event-slot-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
})
export class EventSlotDialogComponent implements OnInit {

  public local_title: string;
  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form
  public catForm: FormGroup;

  public isEdit: boolean; // is insert or update
  public spinner: boolean = false;

  public categoryDataSource: MatTableDataSource<any>

  public categories: Subcategory[] = [];

  public displayedCategoryColumns: string[] = ['icon', 'name', 'delete'];

  public currentSlot: Slot;


  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private _slotService: SlotService,
    private _subcategoryService: SubcategoryService,
    private _authService: AuthService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: Slot
  ) {
    this.loadCategory()
    this.currentSlot = this.data
  }


  ngOnInit() {

    this._adapter.setLocale('pt');

    if (this.data.id != "0") {
      this.isEdit = true;
      this.local_title = this.data.name
    } else {
      this.isEdit = false
      this.local_title = "Vagas"
    }

    this.entityForm = this.createForm()
    this.setFormValues(this.currentSlot, this.entityForm)
    this.catForm = this.createCatForm()
  }


  insert() {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: Slot = this.createEntity(this.entityForm.value);

      this._slotService.insert(entity)
        .then((result) => {
          this.data.id = result.id
          this.isEdit = true;
          this.entityForm.controls.id.setValue(result.id);
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("insert slot error: " + error)
          let msgError: string = this._slotService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }

  }

  update() {
    if (this.entityForm.valid) {

      this.spinner = true;
      let entity: Slot = this.createEntity(this.entityForm.value);

      this._slotService.update(entity)
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("slot update error: " + JSON.stringify(error))
          let msgError: string = this._slotService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }
  }

  createEntity(data: any): Slot {
    let entity = new Slot();
    entity.id = data.id;
    entity.name = data.name;

    entity.event_id = data.event_id;
    entity.event_name = data.event_name;

    entity.slot_quantity = Number(data.slot_quantity);
    entity.slot_used = data.slot_used ? Number(data.slot_used) : 0;
    entity.slot_wait = Number(data.slot_wait);
    entity.slot_wait_used = data.slot_wait_used ? Number(data.slot_wait_used) : 0;

    entity.topic_id = "";
    entity.topic_name = "";

    //entity.categories = data.categories;

    return entity;
  }

  setFormValues(data, form) {
    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);

    form.controls.event_id.setValue(data.event_id);
    form.controls.event_name.setValue(data.event_name);

    form.controls.slot_quantity.setValue(data.slot_quantity);
    form.controls.slot_used.setValue(data.slot_used);
    form.controls.slot_wait.setValue(data.slot_wait);
    form.controls.slot_wait_used.setValue(data.slot_wait_used);

    form.controls.topic_id.setValue(data.topic_id);
    form.controls.topic_name.setValue(data.topic_name);

    this.categoryDataSource = new MatTableDataSource(data.categories)
  //  console.log("data.categories: " + data.categories.length)

  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [Validators.required]),

      event_id: new FormControl(''),
      event_name: new FormControl(''),

      slot_quantity: new FormControl('', [Validators.required]),
      slot_used: new FormControl(''),
      slot_wait: new FormControl('', [Validators.required]),
      slot_wait_used: new FormControl(''),

      topic_id: new FormControl(''),
      topic_name: new FormControl(''),

    });
    return form
  }

  createCatForm() {
    let form: FormGroup = this.fb.group({
      category_id: new FormControl('', [Validators.required])

    });
    return form
  }

  loadCategory() {

    this._subcategoryService.select()
      .subscribe((result) => {

        result.forEach((item) => {

          let entity = new Subcategory();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.hidden = item.payload.doc.data().hidden;
          entity.partner = item.payload.doc.data().partner;
          entity.documents = item.payload.doc.data().documents;
          entity.documents_en = item.payload.doc.data().documents_en;

          this.categories.push(entity)
        })

      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })

  }

  addSlotCategory() {

    let cat = this.categories.find((e) => {
      return e.id == this.catForm.controls.category_id.value
    })

    if (!this.data.categories)
      this.data.categories = []

    this.data.categories.push({
      'id': cat.id,
      'name': cat.name
    })

    this._slotService.updateCategory(this.data.id, this.data.categories)
      .then(() => {
        // console.log(JSON.stringify(this.data.categories))
        this.categoryDataSource = new MatTableDataSource(this.data.categories)

      })
      .catch((error) => {
        console.log(JSON.stringify(error))
      })

  }


  removeSlotCategory(element) {

    let cat_id = element.id

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.name + "<br><br>Excluir esta categoria?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this.data.categories = this.data.categories.filter((e) => {
          return e.id != cat_id
        })

        this._slotService.updateCategory(this.data.id, this.data.categories)
          .then(() => {
            //console.log(JSON.stringify(this.data.categories))
            this.categoryDataSource = new MatTableDataSource(this.data.categories)
          
          })
          .catch((error) => {
            console.log(JSON.stringify(error))
          })
      }
    })
  }


}

